import { entryNodeKey } from '../shared/keys'

const entryMonthKey = (entry) => `${entry.year}-${String(entry.month).padStart(2, '0')}`;

const groupByNodeAndMonth = (entries) => {
  const groups = new Map();

  for (const entry of entries) {
    const key = `${entryNodeKey(entry)}|${entryMonthKey(entry)}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(entry);
  }

  return groups;
};

export const buildHybridEntries = ({ plano, realizado, currentMonthKey }) => {
  const plannedGroups = groupByNodeAndMonth(plano);
  const realizedGroups = groupByNodeAndMonth(realizado);
  const groupKeys = new Set([...plannedGroups.keys(), ...realizedGroups.keys()]);

  const entries = [];

  for (const groupKey of groupKeys) {
    const monthKey = groupKey.slice(groupKey.lastIndexOf('|') + 1);
    const planned = plannedGroups.get(groupKey) ?? [];
    const realized = realizedGroups.get(groupKey) ?? [];

    const isPast = monthKey < currentMonthKey;
    const preferred = isPast ? realized : planned;
    const fallback = isPast ? planned : realized;

    entries.push(...(preferred.length > 0 ? preferred : fallback));
  }

  return entries;
};